import { Component, Input } from '@angular/core';
import {Competitor} from "@model";

@Component({
  selector: 'app-competitor-info',
  templateUrl: './competitor-info.component.html',
  styleUrl: './competitor-info.component.scss',
  standalone: false
})
export class CompetitorInfoComponent {
  @Input() name: string | undefined;
  @Input() isTeam: boolean = false;
  @Input() bib: string | undefined;
  @Input() competitor: Competitor | undefined;
}
